// extracted by mini-css-extract-plugin
module.exports = {"title":"_4ee7e","label":"_98548","wrapper":"_130a5","form":"eda75","loading":"_40eb9","tags":"a9b9c","footer":"_395f4"};